import { useEffect } from "react";
import { useDispatch, useSelector } from "@/core/redux/store";
import { getSpecificationSupplierProductsThunk } from "@/core/redux/thunks/supplierResponsesAllThunk";
import TableRowProductSupplierResponses from "./product-supplier-responses/product-supplier-responses";
import {
  LoadingState,
  ErrorState,
  EmptyState,
} from "./product-supplier-responses/ui-states";

interface TableRowDetailsProps {
  specificationId: string;
}

const DEFAULT_LIMIT = 10;

export default function TableRowDetails({
  specificationId,
}: TableRowDetailsProps) {
  const dispatch = useDispatch();
  const productState = useSelector(
    (state) =>
      state.supplierResponsesAll.productsBySpecification[specificationId]
  );

  const isLoading = productState?.isLoading ?? false;
  const error = productState?.error ?? null;
  const products = productState?.items ?? [];
  const initialized = productState?.initialized ?? false;

  useEffect(() => {
    dispatch(
      getSpecificationSupplierProductsThunk({
        specificationId,
        limit: DEFAULT_LIMIT,
      })
    );
  }, [dispatch, specificationId]);

  if (isLoading && !initialized) {
    return <LoadingState />;
  }

  const errorMessage =
    typeof error === "string" ? error : error ? "Bir hata oluştu" : null;

  if (errorMessage) {
    return <ErrorState error={errorMessage} />;
  }

  if (!isLoading && products.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className="flex flex-col">
      {!isLoading && products.map((product, index) => (
        <TableRowProductSupplierResponses
          index={index}
          key={`${specificationId}-${product.productId}`}
          product={product}
        />
      ))}
      {isLoading && initialized && <LoadingState />}
    </div>
  );
}
